import { Typography } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';
import { UserEditFormProps, UsersEditForm } from '../users-edit-form';

interface UsersEditDialogProps extends UserEditFormProps {
  title?: string;
  popDialog?: any;
}

export const UsersEditDialog: ComponentType<UsersEditDialogProps> = ({
  title: dialogTitle,
  id,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const defaultTitle = !!id
    ? t('users.edit', 'Редактировать пользователя')
    : t('users.add', 'Добавить пользователя');
  const title = dialogTitle ? dialogTitle : defaultTitle;

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      {title && (
        <Typography variant="h2" component="h6" mb={2}>
          {title}
        </Typography>
      )}
      <UsersEditForm id={id} onSubmit={onSubmit} onCancel={popDialog} />
    </BaseDialog>
  );
};
